import React, { Component } from 'react';
// import PropTypes from 'prop-types';

export default class UnityGlobalNav extends Component {
  state = {
    collapsed: this.props.collapsed || false,
  };

  constructor(props) {
    super(props);
    this.navRef = React.createRef();
  }

  componentDidMount() {
    this.updateProps({});
    const nav = this.navRef.current;
    if (nav) nav.onToggleCollapse = this.handleToggleCollapse;
  }

  componentDidUpdate(oldProps) {
    this.updateProps(oldProps);
  }

  updateProps(oldProps = {}) {
    const { items = {}, onSelect, onOpenStateChange, openStates } = this.props;
    const { items: oldItems, onSelect: oldOnSelect, onOpenStateChange: oldOnOpenStateChange, openStates: oldOpenStates } = oldProps;
    const nav = this.navRef.current;

    if (nav) {
      if (items !== oldItems) nav.items = items;
      if (onSelect !== oldOnSelect) nav.onSelect = onSelect;
      if (onOpenStateChange !== oldOnOpenStateChange) nav.onOpenStateChange = onOpenStateChange;
      if (openStates !== oldOpenStates) nav.openStates = openStates;
    }
  }

  handleToggleCollapse = (collapsed) => {
    const { onToggleCollapse } = this.props;
    this.setState({ collapsed });
    if (onToggleCollapse) onToggleCollapse(collapsed);
  };

  render() {
    const {
      gutter,
      collapsible,
      collapsed,
      grid,
      subHeaderBorder,
      alwaysShowBordersTop,
      alwaysShowBordersBottom,
      bubbleBottomItems,
      style: stylesProp,
      items,
      onSelect,
      customHeader,
      customExpandedHeader,
      subHeader,
      collapsedSubHeader,
      ...otherProps
    } = this.props;
    const { collapsed: collapsedState } = this.state;
    let sideNavProps = { ...otherProps };
    if (gutter) sideNavProps.gutter = gutter;
    if (collapsible) sideNavProps.collapsible = collapsible;
    if (collapsed) sideNavProps.collapsed = collapsed;
    if (grid) sideNavProps.grid = grid;
    if (subHeaderBorder) sideNavProps.subHeaderBorder = subHeaderBorder;
    if (alwaysShowBordersTop) sideNavProps.alwaysShowBordersTop = alwaysShowBordersTop;
    if (alwaysShowBordersBottom) sideNavProps.alwaysShowBordersBottom = alwaysShowBordersBottom;
    if (bubbleBottomItems) sideNavProps.bubbleBottomItems = bubbleBottomItems;

    return (
      <unity-global-nav-base ref={this.navRef} style={stylesProp} {...sideNavProps}>
        {customHeader && <span slot="customHeader">{customHeader}</span>}
        {customExpandedHeader && <span slot="customExpandedHeader">{customExpandedHeader}</span>}
        {!collapsedState ? (
          subHeader && <span slot="subHeader">{subHeader}</span>
        ) : (
          collapsedSubHeader && <span slot="collapsedSubHeader">{collapsedSubHeader}</span>
        )}
      </unity-global-nav-base>
    );
  }
}
//
// UnityGlobalNav.propTypes = {
//   gutter: PropTypes.bool,
//   logo: PropTypes.string,
//   selected: PropTypes.string,
//   collapsible: PropTypes.bool,
//   collapsed: PropTypes.bool,
//   items: PropTypes.object,
//   onSelect: PropTypes.func,
//   header: PropTypes.string,
//   headerImg: PropTypes.string,
//   grid: PropTypes.bool,
//   children: PropTypes.any,
//   style: PropTypes.object,
//   customHeader: PropTypes.node,
//   customExpandedHeader: PropTypes.node,
//   subHeader: PropTypes.node,
//   collapsedSubHeader: PropTypes.node,
//   subHeaderBorder: PropTypes.bool,
//   onToggleCollapse: PropTypes.func,
//   onOpenStateChange: PropTypes.func,
//   openStates: PropTypes.object,
//   alwaysShowBordersTop: PropTypes.bool,
//   alwaysShowBordersBottom: PropTypes.bool,
//   bubbleBottomItems: PropTypes.bool,
//   selectFirstChildOnExpand: PropTypes.bool,
// };